import { useCallback } from "react";

const HMenuItemInner = ({ item, parentItem }) => {
  // MenuConfig supplies an MUI icon component rather than a class name.
  const Icon = item.icon;
  const itemCssClassWithBullet = useCallback((item, parentItem) => {
    if (item.bullet) {
      return `kt-menu__link-bullet--${item.bullet}`;
    }

    if (parentItem && parentItem.bullet) {
      return `kt-menu__link-bullet--${parentItem.bullet}`;
    }

    return "";
  }, []);

  return (
    <>
      {/* if menu item has icon */}
      {Icon && <Icon className="kt-menu__link-icon" fontSize="inherit" />}

      {/* if menu item using bullet */}
      {!Icon && (item.bullet || (parentItem && parentItem.bullet)) && (
        <i className={`kt-menu__link-bullet ${itemCssClassWithBullet(item, parentItem)}`}>
          <span />
        </i>
      )}

      {!item.badge ? (
        <>
          <span className="kt-menu__item-here" />
          {/* menu item title text */}
          <span className="kt-menu__link-text">{item.title}</span>
        </>
      ) : (
        <>
          {/* menu item with badge */}
          <span className="kt-menu__link-text">{item.title}</span>
          <span className="kt-menu__link-badge">
            <span
              className={`kt-badge kt-badge--brand kt-badge--inline kt-badge--pill ${item.badge.type} `}
            >
              {item.badge.value}
            </span>
          </span>
        </>
      )}
    </>
  );
};

export default HMenuItemInner;
